import * as Sentry from "@sentry/react";

const SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN;

export function initSentry() {
  if (!SENTRY_DSN) {
    console.warn("Sentry DSN not configured. Skipping Sentry initialization.");
    return;
  }

  Sentry.init({
    dsn: SENTRY_DSN,
    environment: import.meta.env.MODE,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ],

    // Performance monitoring: capture 20% of transactions in production
    tracesSampleRate: import.meta.env.MODE === "production" ? 0.2 : 1.0,

    // Session replay: capture 10% of sessions, 100% of sessions with errors
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,

    // Only send errors from our own domain
    allowUrls: [window.location.origin],

    // Scrub sensitive data before sending
    beforeSend(event) {
      if (event.breadcrumbs) {
        event.breadcrumbs = event.breadcrumbs.map((breadcrumb) => {
          if (breadcrumb.category === "xhr" || breadcrumb.category === "fetch") {
            if (breadcrumb.data) {
              delete breadcrumb.data["request_body"];
            }
          }
          return breadcrumb;
        });
      }
      return event;
    },
  });
}

export { Sentry };
